
import { useState } from "react";

const Accordion = ({ title, children, isOpenDefault = false }) => {
  const [isOpen, setIsOpen] = useState(isOpenDefault);

  return (
    <div className="accordian">
      <div
      className="head v-center justify-content-between"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h5 className="fw-semibold text-gray">{title}</h5>
        <span className="ml-2">{isOpen ? "−" : "+"}</span>
      </div>

      {isOpen && <div className="body">{children}</div>}
    </div>
  );
};

export default Accordion;
